/**
 * Shared event name and opener for the in-app bug report modal.
 *
 * Lives in its own file so BugReportModal.tsx can remain a pure component
 * export (required by React Fast Refresh).
 */

export const BUGREPORT_OPEN_EVENT ="bugreport:open";

export const openBugReportModal = (): void => {
 if (typeof window ==="undefined") return;
 window.dispatchEvent(new CustomEvent(BUGREPORT_OPEN_EVENT));
};
